import DesignListRow from './design-list-row';

export default DesignListRow;
